import _ from 'lodash'

// como texto: os fluxos que pre-preenchem o contrato podem trazer o id como string e a lista traz numero
const oidDo = (tipo) => {
  const oid = _.get(tipo, 'oid', null) || _.get(tipo, 'id', null)
  return oid === null || oid === undefined || oid === '' ? null : String(oid)
}

/** Aviso sobre o tipo atual do contrato. */
export const AVISO_TIPO_CONTRATO = {
  // contrato ja gravado com tipo inativo: o valor continua (o back aceita manter o tipo que o contrato ja tinha)
  MANTIDO: 'contrato.label.avisoTipoContratoInativo',
  // contrato novo vindo preenchido com tipo inativo (cremacao, destino, localizacao): o back recusa, tem de trocar
  NOVO: 'contrato.label.avisoTipoContratoInativoNovo',
}

/**
 * Opcoes do campo Tipo de Contrato (tipoSepultura) no Contrato. Tipo inativo nao e oferecido - nao da para escolher um
 * tipo inativo. No contrato ja gravado, o tipo atual continua entre as opcoes mesmo inativo, para o valor seguir
 * aparecendo, com aviso. No contrato novo, um tipo inativo vindo preenchido fica fora das opcoes, com aviso para trocar.
 *
 * A lista completa (com os inativos) continua no store: as configuracoes do tipo (plano, funeral, cremacao...) do
 * contrato existente dependem dela. Sem o campo ativo (back anterior ao deploy), nada e filtrado.
 *
 * @param tipos lista de GET loadAll (TipoSepulturaDTO)
 * @param tipoAtual record.tipoSepultura do contrato
 * @param contratoGravado o contrato ja existe (tem oid)
 * @returns {{ opcoes: Array, aviso: string|null }} aviso = chave do dicionario (AVISO_TIPO_CONTRATO) ou null
 */
export const opcoesTipoContrato = (tipos, tipoAtual, contratoGravado) => {
  const lista = tipos || []
  const oidAtual = oidDo(tipoAtual)
  const atualInativo =
    !!oidAtual && (_.get(tipoAtual, 'ativo') === false || lista.some((t) => oidDo(t) === oidAtual && t.ativo === false))
  const manterAtual = atualInativo && !!contratoGravado
  const opcoes = lista.filter((t) => t.ativo !== false || (manterAtual && oidDo(t) === oidAtual))
  let aviso = null
  if (atualInativo) {
    aviso = contratoGravado ? AVISO_TIPO_CONTRATO.MANTIDO : AVISO_TIPO_CONTRATO.NOVO
  }
  return { opcoes, aviso }
}
